import React, { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../CommonComponents/CommonCardHeader/CommonCardHeader";
import { BackgroundPillTabTitle } from "../../../../Constants/Constants";
import { BackgroundPillTabSubTitle } from "../../../../Data/UiKits/Tabs";
import BackgroundPillNav from "./BackgroundPillNav";
import BackgroundPillTabContent from "./BackgroundPillTabContent";

const BackgroundPillTab = () => {
  const [basicTab, setBasicTab] = useState("3");

  return (
    <Col xxl="6">
      <Card>
        <CommonCardHeader title={BackgroundPillTabTitle} span={BackgroundPillTabSubTitle} />
        <CardBody className="bg-navbar">
          <BackgroundPillNav basicTab={basicTab} setBasicTab={setBasicTab} />
          <BackgroundPillTabContent tabId={basicTab} />
        </CardBody>
      </Card>
    </Col>
  );
};

export default BackgroundPillTab;
